import { Box } from '@mui/material';

import { useBoardSelectionStore } from '@walls/store';

export function BoardSelectionOverlay() {
  const selectionArea = useBoardSelectionStore((state) => state.selectionArea);

  if (!selectionArea) {
    return null;
  }

  let height = Number(selectionArea.height ?? 0);
  let width = Number(selectionArea.width ?? 0);

  if (height <= 0 || width <= 0) {
    return null;
  }

  if (height < 1) height = 1.01;
  if (width < 1) width = 1.01;

  return (
    <Box
      id="selection-area"
      sx={{
        backgroundColor: 'rgba(125, 201, 251, 0.5)',
        border: '2px solid #7dc9fb',
        boxSizing: 'border-box',
        height,
        left: selectionArea.x,
        outline: '2px solid transparent',
        pointerEvents: 'none',
        position: 'absolute',
        top: selectionArea.y,
        width,
        zIndex: 999,
      }}
    />
  );
}
